import React from "react";
import { Grid, Avatar, Box, Typography, useTheme, Button } from "@mui/material";
import { CompanyDetails } from "../../../../../../types/companies-managment/Company";
import MainCard from "../../../../../../components/MainCard";

interface AccountHolderProps {
  company: CompanyDetails;
}

const AccountHolder: React.FC<AccountHolderProps> = ({ company }) => {
  const theme = useTheme();

  return (
    <MainCard
      title="Account holders"
      headerActions={
        <Button color="primary" variant="contained">
          Change password
        </Button>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} display="flex" alignItems="center">
          <Avatar
            src={company.logo || ""}
            alt={company.name_en || company.user_name}
            sx={{
              width: 200,
              height: 200,
              border: "2px solid #E9E9E9",
              objectFit: "contain",
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={9}
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            padding: "1rem",
            gap: "1rem",
          }}
        >
          {company?.user_name && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "20%",
                }}
              >
                User name :
              </Typography>
              <Typography
                sx={{
                  width: "80%",
                }}
              >
                {company?.user_name}
              </Typography>
            </Box>
          )}
          {company?.created_at && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "20%",
                }}
              >
                Created at :
              </Typography>
              <Typography
                sx={{
                  width: "80%",
                }}
              >
                {company?.created_at}
              </Typography>
            </Box>
          )}
          {company?.registration_date && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "20%",
                }}
              >
                Registration date :
              </Typography>
              <Typography
                sx={{
                  width: "80%",
                }}
              >
                {company?.registration_date}
              </Typography>
            </Box>
          )}
          {company?.registration_date && (
            <Box sx={{ display: "flex", gap: "1rem", width: "100%" }}>
              <Typography
                color="GrayText"
                sx={{
                  width: "20%",
                }}
              >
                Last sign in :
              </Typography>
              <Typography
                sx={{
                  width: "80%",
                }}
              >
                {company?.registration_date}
              </Typography>
            </Box>
          )}
          {/* <Link
            to="/"
            style={{
              color: theme.palette.primary.main,
              textDecoration: "none",
            }}
          >
            Change password
          </Link> */}
        </Grid>
      </Grid>
    </MainCard>
  );
};

export default AccountHolder;
